/**
 * One section of the checklist: section title and a list of ChecklistItemRating items.
 */
import React from 'react';

import { ChecklistItemRating } from './ChecklistItemRating';
import type { ChecklistSection as ChecklistSectionType, ChecklistState } from '../types';

interface ChecklistSectionProps {
  section: ChecklistSectionType;
  state: ChecklistState;
  onRate: (itemId: string, rating: number) => void;
  onToggleExpand: (itemId: string) => void;
  allItemsMap: Map<number, { id: string; title: string }>;
}

export const ChecklistSection: React.FC<ChecklistSectionProps> = ({
  section,
  state,
  onRate,
  onToggleExpand,
  allItemsMap,
}) => {
  return (
    <section
      className="mb-16"
      id={section.id}
      aria-labelledby={`section-${section.id}-title`}
    >
      <div className="mb-8">
        <div className="text-xs font-semibold text-primary uppercase tracking-wider mb-2">
          Section {section.number}
        </div>
        <h2
          id={`section-${section.id}-title`}
          className="text-2xl sm:text-3xl font-bold text-text-primary tracking-tight"
        >
          {section.title}
        </h2>
      </div>

      <div className="space-y-8" role="list" aria-label={`Items in ${section.title}`}>
        {section.items.map((item) => (
          <ChecklistItemRating
            key={item.id}
            item={item}
            rating={state[item.id]?.rating ?? null}
            expanded={state[item.id]?.expanded ?? true}
            onRate={onRate}
            onToggleExpand={onToggleExpand}
            allItemsMap={allItemsMap}
          />
        ))}
      </div>
    </section>
  );
};
